import { useEffect, useState } from 'react';
import {
    PanelBody,
    Button,
    Modal,
    TextControl,
    SelectControl,
    TextareaControl,
    CheckboxControl,
    __experimentalNumberControl as NumberControl,
    Spinner,
    ColorPalette,
    RadioControl,
    __experimentalText as Text
} from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { fetchData, saveData } from './api';
const LayoutTab = ({ openPopup , setActiveTab }) => {
    const [isSaving, setIsSaving] = useState(false);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [modifiedFields, setModifiedFields] = useState({});
    useEffect(() => {
        // Fetch settings from the REST API
        fetchData(gmwcp_wp_ajax.getsettings, gmwcp_wp_ajax.nonce)
            .then((fetchedData) => {
                setData(fetchedData);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                console.error('Error fetching settings:', error);
            });
    }, []);

    const updateField = (field, value) => {
        setData((prevData) => ({
            ...prevData,
            [field]: value,
        }));
        setModifiedFields((prevFields) => ({
            ...prevFields,
            [field]: value,
        }));
    };
    const toggleCheckbox = (fieldName, key) => {
        setData((prevData) => {
            const currentValues = prevData[fieldName] || [];
            const updatedValues = currentValues.includes(key)
                ? currentValues.filter((item) => item !== key) // Remove key if already present
                : [...currentValues, key]; // Add key if not present
            return {
                ...prevData,
                [fieldName]: updatedValues,
            };
        });
        setModifiedFields((prevFields) => ({
            ...prevFields,
            [fieldName]: data[fieldName]?.includes(key)
                ? data[fieldName].filter((item) => item !== key)
                : [...(data[fieldName] || []), key],
        }));
    };

    const saveSettings = () => {
        if (Object.keys(modifiedFields).length === 0) {
            openPopup('No changes to save.');
            return;
        }
        setIsSaving(true);

        saveData(gmwcp_wp_ajax.savedata, gmwcp_wp_ajax.nonce, modifiedFields)
            .then((responseData) => {
                setIsSaving(false);
                if (responseData.success) {
                    openPopup('Settings saved!');
                    setModifiedFields({});
                } else {
                    openPopup('Failed to save settings.');
                }
            })
            .catch((error) => {
                setIsSaving(false);
                console.error('Error saving settings:', error);
                openPopup('Failed to save settings.');
            });
    };
    return (
        <PanelBody>
         {loading ? (
                <Spinner />
            ) : (
                <>
          <table className="GMadminTable">
                            <tr>
                                <th>
                                    <label>Header Text</label>
                                </th>
                                <td>
                                     <TextareaControl
                         onChange={(value) => updateField('gmpcp_header_text', value)}
                                    value={data.gmpcp_header_text}
                                     disabled="true"
                      />
                      <div><a href="https://www.codesmade.com/store/pdf-catalog-woocommerce-pro/" target="_blank">Get Pro Version</a></div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label>Footer Text</label>
                                </th>
                                <td>
                                     <TextareaControl
                         onChange={(value) => updateField('gmpcp_footer_text', value)}
                                    value={data.gmpcp_footer_text}
                                     disabled="true"
                      />
                      <div><a href="https://www.codesmade.com/store/pdf-catalog-woocommerce-pro/" target="_blank">Get Pro Version</a></div>
                                </td>
                            </tr>
                              <tr>
                                <th>
                                    <label>Background Color</label>
                                </th>
                                <td>
                                     <ColorPalette
                         onChange={(value) => updateField('gmpcp_background_color', value)}
                                    value={data.gmpcp_background_color}
                      />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label>Text Color</label>
                                </th>
                                <td>
                                     <ColorPalette
                         onChange={(value) => updateField('gmpcp_text_color', value)}
                                    value={data.gmpcp_text_color}
                      />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label>Header/Footer Background Color</label>
                                </th>
                                <td>
                                     <ColorPalette
                         onChange={(value) => updateField('gmpcp_hf_background_color', value)}
                                    value={data.gmpcp_hf_background_color}
                      />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label>Header/Footer Text Color</label>
                                </th>
                                <td>
                                     <ColorPalette
                         onChange={(value) => updateField('gmpcp_hf_text_color', value)}
                                    value={data.gmpcp_hf_text_color}
                      />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label>Product Title Font Size</label>
                                </th>
                                <td>
                                   <NumberControl
                            
                                    help="Enter Number Product Title Font Size"
                                    onChange={(value) => updateField('gmpcp_product_title_font_size', value)}
                                    value={data.gmpcp_product_title_font_size}
                                  />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label>Product Content Font Size</label>
                                </th>
                                <td>
                                   <NumberControl
                            
                                    help="Enter Number Product Content Font Size"
                                    onChange={(value) => updateField('gmpcp_product_content_font_size', value)}
                                    value={data.gmpcp_product_content_font_size}
                                  />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label>Direction</label>
                                </th>
                                <td>
                                    <RadioControl
                                    selected={data.gmwcp_direction}
                                    options={ [
                                        { label: 'LTR', value: 'ltr' },
                                        { label: 'RTL', value: 'rtl' },
                                    ] }
                                    onChange={(value) => updateField('gmwcp_direction', value)}
                                   
                                />
                                </td>
                            </tr>
                            
          </table>
                  <Button isPrimary onClick={saveSettings} disabled={isSaving}>
                            {isSaving ? <Spinner /> : 'Save Settings'}
                        </Button>
                 
                   </>
            )}
        </PanelBody>
    );
};

export default LayoutTab;
